import { render, staticRenderFns } from "./SelectStamp.vue?vue&type=template&id=479c6e1c&scoped=true"
import script from "./SelectStamp.vue?vue&type=script&lang=js"
export * from "./SelectStamp.vue?vue&type=script&lang=js"
import style0 from "./SelectStamp.vue?vue&type=style&index=0&id=479c6e1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479c6e1c",
  null
  
)

export default component.exports